import {
  InAppMessage,
  DecisionReason,
  HackleEvent,
  HackleUser,
  InAppMessageContextMessage,
  Long,
  Properties
} from "../../../core/internal/model/model"
import { InAppMessageDeliverRequest } from "../deliver/InAppMessageDeliverRequest"
import { InAppMessageDeliverEvaluation } from "../deliver/evaluator/InAppMessageDeliverEvaluation"

export class InAppMessagePresentRequest {
  constructor(
    public readonly dispatchId: string,
    public readonly inAppMessage: InAppMessage,
    public readonly message: InAppMessageContextMessage,
    public readonly user: HackleUser,
    public readonly requestedAt: Long,
    public readonly reason: DecisionReason,
    public readonly properties: Properties,
    public readonly triggerEvent: HackleEvent
  ) {}

  /**
   * @override
   */
  toString() {
    return `InAppMessagePresentRequest(dispatchId=${this.dispatchId}, inAppMessage=${this.inAppMessage}, user=${this.user.identifiers}, requestedAt=${this.requestedAt}, reason=${this.reason}, properties=${this.properties}, triggerEvent=${this.triggerEvent.key})`
  }

  static of(
    request: InAppMessageDeliverRequest,
    user: HackleUser,
    evaluation: InAppMessageDeliverEvaluation
  ): InAppMessagePresentRequest {
    return new InAppMessagePresentRequest(
      request.dispatchId,
      evaluation.eligibility.evaluation.entity,
      evaluation.layout.evaluation.result.message,
      user,
      request.requestedAt,
      evaluation.eligibility.evaluation.result.reason,
      { ...request.properties, ...evaluation.toProperties() },
      request.triggerEvent
    )
  }
}
